import React, { JSX, memo, useMemo } from 'react';

import { View } from 'react-native';

import { EPGConfig } from '../../types';
import getStyles from './styles';

type Props = {
    config: EPGConfig;
    time: number;
    renderContent: (time: number) => JSX.Element;
};

const HourCell = ({ config, time, renderContent }: Props) => {
    const styles = useMemo(() => getStyles(config), []);

    return <View style={styles.container}>{renderContent(time)}</View>;
};

export default memo(HourCell);
